import React from 'react';

export default function Page404() {
  return (
    <div>
      <h1> Error 404! Page not found</h1>
    </div>
  );
}
